import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import DashboardLayout from '../components/DashboardLayout';
import ForumCategoriesList from '../components/forums/ForumCategoriesList';
import ForumGuidelines from '../components/forums/ForumGuidelines';
import { Button } from '../components/ui/button';
import { MessageSquare, Plus, ScrollText, MessagesSquare } from 'lucide-react';
import { cn } from '@/lib/utils';
import { useTheme } from '@/contexts/ThemeContext';

const Forums: React.FC = () => {
  const { isDarkMode } = useTheme();
  const navigate = useNavigate();
  const [isLoading, setIsLoading] = useState(false);

  return (
    <DashboardLayout>
      <div className="space-y-6">
        {/* Header */}
        <div className={cn(
          "flex flex-col sm:flex-row items-start sm:items-center justify-between gap-4",
          "pb-4 border-b",
          isDarkMode ? "border-dark-300" : "border-light-300"
        )}>
          <div>
            <h1 className={cn(
              "text-2xl font-bold",
              isDarkMode ? "text-white" : "text-light-900"
            )}>
              <div className="flex items-center gap-2">
                <MessagesSquare className="h-6 w-6 text-gold-400" />
                <span>Forums</span>
              </div>
            </h1>
            <p className={cn(
              "mt-1",
              isDarkMode ? "text-white/70" : "text-light-600"
            )}>
              Connect with the playclub community, share experiences, and engage in  conversations
            </p>
          </div>
          <div className="flex flex-row gap-2">
            <Button
              onClick={() => navigate('/dashboard/forums/new-topic')}
              className={cn(
                "bg-gold-400 hover:bg-gold-500 text-dark-50",
                "flex items-center gap-2"
              )}
            >
              <Plus className="h-4 w-4" />
              <span>New Topic</span>
            </Button>
            <Button
              onClick={() => navigate('/dashboard/feed')}
              className={cn(
                "bg-dark-300 hover:bg-dark-400 text-white",
                "flex items-center gap-2"
              )}
            >
              <ScrollText className="h-4 w-4" />
              <span>Social Feed</span>
            </Button>
          </div>
        </div>

        {/* Categories */}
        <div className="space-y-6">
          <ForumGuidelines />
          
          <ForumCategoriesList />
        </div>

        {/* Recent Activity */}
        <div className={cn(
          "mt-8 p-6 rounded-xl border text-center",
          isDarkMode ? "bg-dark-200 border-dark-300" : "bg-light-100 border-light-300"
        )}>
          <MessageSquare className="h-12 w-12 mx-auto text-gold-400 mb-4" />
          <h3 className={cn(
            "text-lg font-medium mb-2",
            isDarkMode ? "text-white" : "text-light-900"
          )}>Join the Conversation</h3>
          <p className={cn(
            "mb-4",
            isDarkMode ? "text-white/70" : "text-light-600"
          )}>
            Share your experiences, ask questions, and connect with other members in our themed community spaces.
          </p>
          <div className="flex flex-col sm:flex-row gap-3 justify-center">
            <Button
              onClick={() => navigate('/dashboard/forums/new-topic')}
              className="bg-gold-400 hover:bg-gold-500 text-dark-50"
            >
              <Plus className="h-4 w-4 mr-2" />
              Start a New Topic
            </Button>
          </div>
        </div>
      </div>
    </DashboardLayout>
  );
};

export default Forums;